<template>
    <div class="registry-wrapper">
        <empty-table-message v-if="isEmpty" />
        <b-table
            v-else
            :data="perguntasRespostas"
            class="data-table"
            @sort="sortTable"
            backend-sorting
        >
            <b-table-column
                v-for="(f, i) in fields"
                :key="i"
                :field="f.key"
                :width="f.width"
                :label="f.label ? $t(f.label) : $t(f.key)"
                :sortable="f.sortable"
                :centered="f.centered"
                :visible="f.visible"
                v-slot="props"
            >
                <div v-if="f.key === 'dataHora'">
                    {{ $moment(props.row[f.key]).format('L LTS') }}
                </div>
                <div v-else-if="f.key === 'resposta'">
                    {{ textFormatter(props.row[f.key], props.row.tipoPergunta) }}
                </div>
                <div v-else>
                    {{ isNull(props.row[f.key]) ? $t('nao-informado') : props.row[f.key] }}
                </div>
            </b-table-column>
        </b-table>
        <PaginationViewer
            class="mb-0"
            :resetPagination="pagination.resetPagination"
            :totalItems="pagination.totalRows"
            :perPageOptions="pagination.perPageOptions"
            :optionStarted="pagination.optionStarted"
            @change="updatePagination"
        />
    </div>
</template>

<script>
export default {
    name: 'Respostas',

    props: {
        filters: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            fields: [
                { key: 'dataHora', label: 'data-hora', sortable: true, width: 175 },
                { key: 'nomeColaborador', label: 'colaborador', sortable: true },
                {
                    key: 'nomeCliente',
                    label: 'cliente',
                    sortable: true,
                    visible: this.$route.meta.abrev != 'serv',
                },
                { key: 'pergunta', label: 'pergunta', sortable: true },
                { key: 'resposta', label: 'resposta', sortable: true },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            perguntasRespostas: [],
            isEmpty: false,
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.carregarDados();
    },
    watch: {
        filters: {
            deep: true,
            handler() {
                this.carregarDados();
            },
        },
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.$emit('updateIsLoading', true);

            this.$axios
                .post(
                    `/${this.$route.meta.abrev}/formRespostaCabecalho/allByIdFormAndOrigem`,
                    this.filters,
                    {
                        params: {
                            idFormulario: +this.$route.params.idFormulario,
                            origem: this.$route.query.origem,
                            page: currentPage - 1,
                            limit: this.pagination.perPage,
                        },
                    }
                )
                .then((response) => {
                    this.isEmpty = response.data.content.length === 0;

                    this.perguntasRespostas = this.mapDataToTable(response.data.content);

                    this.pagination.totalRows = response.data.totalElements;
                })
                .catch((_) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally((_) => {
                    this.$emit('updateIsLoading', false);
                });
        },
        mapDataToTable(data) {
            return data.map((item) => {
                return {
                    dataHora: item.data_hora_finalizacao,
                    nomeColaborador: item.usuario.nome,
                    nomeCliente: item.cliente ? item.cliente.nome : '',
                    pergunta: item.formPergunta.descricao,
                    tipoPergunta: item.formPergunta.item_tipo,
                    resposta: item.formRespostaPreenchida.resposta,
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.$emit('updateFilter', {
                field,
                order,
            });
        },
        textFormatter(value, dataType) {
            if (this.isNull(value)) return this.$t('nao-informado');

            switch (dataType) {
                case 'DECIMAL':
                    return this.getDecimal(value);
                case 'PERCENT':
                    return this.parseAsPercent(value);
                case 'DATE':
                    return this.$moment(value).format('L');
                case 'DATETIME':
                    return this.$moment(value).format('L LTS');
                default:
                    return value;
            }
        },
    },
};
</script>
